import { render, staticRenderFns } from "./agendamento_cliente.vue?vue&type=template&id=3453f5bc&scoped=true"
import script from "./agendamento_cliente.vue?vue&type=script&lang=js"
export * from "./agendamento_cliente.vue?vue&type=script&lang=js"
import style0 from "./agendamento_cliente.vue?vue&type=style&index=0&id=3453f5bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3453f5bc",
  null
  
)

export default component.exports